import {
  IFeatureModalData,
  IControlButtonTexts
} from 'module/productfeaturemodal/productfeaturemodal.types'

export const migrationFeatureModalLink =
  'https://challenges.aflmint.com.au/articles/afl-mint-base-blockchain-101'

export const migrationFeatureModalData: IFeatureModalData[] = [
  {
    image: '/assets/Image/migrations-popup.jpg',
    tag: 'AFL MINT UPDATE',
    heading: 'AFL Mint has migrated to Base',
    body: `Flow blockchain faced operational challenges that limited our ability to serve the collector community. Base is more widely used, technologically mature, and has hundreds of thousands of thriving projects. Your entire collection has been automatically preserved and mapped 1:1 from Flow to Base as historical digital collectibles.`
  },
  {
    image: '/assets/Image/migrations-3-popup.jpg',
    tag: 'AFL MINT UPDATE',
    heading: 'Your new Crossmint wallet',
    body: `You'll receive a new Crossmint wallet automatically tied to your
          AFL ID and email address. Buy packs and moments the same way—using
          USDC funds found in your wallet via Crossmint. Funds can be topped up using your bank card or transferring USDC on Base. Make sure to use the same email to log in.`
  },
  {
    image: '/assets/Image/migrations-4-popup.jpg',
    tag: 'AFL MINT UPDATE',
    heading: 'Trading your collectibles',
    body: (
      <div>
        The AFL Mint marketplace remains unchanged. If you had moments listed
        for sale before migration, you&apos;ll just need to re-list them.
        Approximately 7 days after migration completion, AFL will become visible
        on Opensea. We are working on the smoothest possible transition for your
        collectibles to be tradable on Opensea.
        <p className="mt-2 text-sm text-white">
          For more information{' '}
          <a
            href="https://challenges.aflmint.com.au/articles/afl-mint-base-blockchain-101"
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue3"
          >
            read here
          </a>
          .
        </p>
      </div>
    )
  }
]

export const migrationControlButtonTexts: IControlButtonTexts = {
  prev: 'Back',
  next: 'Next',
  end: 'Got it'
}
